import 'core-js'
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import App from './App.vue'
import { defaultFormData, getSessionFormData, setSessionFormData } from './data/formData'
import { store } from './store'
import '@/utils/validation.js'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/styles/index.scss'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker'
import '@/utils/registerComponents.js'
import baseApi from './api/common/baseApi.js'
import storage from './utils/storage.js'
import { STORAGE } from './api/common/config.js'

import formDataMock from './data/formData-mock.js'

import { InlineSvgPlugin } from 'vue-inline-svg'
import quoteService from './api/services/quoteService.js'

import helper from './utils/helper'
// language
import i18n from './localization/lang/i18n'
import { languages } from './localization/lang/languages'

import quickQuoteHandler from './api/services/quickQuoteHandler'

Vue.use(InlineSvgPlugin)

let antiForgery = ''

// AntiForgery token
if (process.env.NODE_ENV === 'production') {
	// antiForgery = window.antiForgeryToken
	// Vue.prototype.$antiForgeryToken = antiForgery
	// document.cookie = `CSRF-TOKEN=${antiForgery}`;
} else {
	antiForgery = helper.getCookie('XSRF-TOKEN')
	window.antiForgeryToken = antiForgery
}

Vue.use(VueToast)

function fillOptionData(dataOptions) {
	// get min, max age relationship
	dataOptions.relationships.forEach((d) => {
		d.minAgeToBeOnPolicy = Number(d.field1)
		d.maxAgeToBeOnPolicy = Number(d.field2)
		d.minAgeToBeOnPolicyWithoutPh = Number(d.field3)
		d.maxAgeToBeOnPolicyWithoutPh = Number(d.field4)
	})
}

function Bootstrap(dataOptions, broker) {
	fillOptionData(dataOptions)
	Vue.prototype.$agePolicyHolder = {
		minAge: dataOptions.relationships[0].minAgeToBeOnPolicy,
		maxAge: dataOptions.relationships[0].maxAgeToBeOnPolicy,
		minAgeWithoutPh: dataOptions.relationships[0].minAgeToBeOnPolicyWithoutPh,
		maxAgeWithoutPh: dataOptions.relationships[0].maxAgeToBeOnPolicyWithoutPh,
	}

	dataOptions.relationships.shift()
	Vue.prototype.$quote = Vue.observable(storage.getSession(STORAGE.QUOTE) || {})
	Vue.prototype.$broker = broker

	Vue.prototype.$state = Vue.observable({
		showApp: true, // State for re-render vue app
		isSubmitFormProcessing: storage.getSession(STORAGE.iS_SUBMIT_FORM_PROCESSING) || false,
		isApplyOrPaymentComplete: storage.getSession(STORAGE.APPLY_PAYMENT_SUCCESS) || false,
		paymentAcceptedOrException: storage.getSession(STORAGE.PAYMENT_ACCEPT_EXCEPTION) || false,
	})

	Vue.prototype.$eventBus = new Vue()

	// Save screenshot file in final step
	Vue.prototype.$screenshot = {
		fileName: '',
		base64: '',
		contentType: '',
	}

	Vue.prototype.$memberCard = null

	//store file name upload in step 3
	Vue.prototype.$fileUpload = storage.getSession(STORAGE.FILE_UPLOADED) || []

	// collapse item member when screen shot
	Vue.prototype.$isCollapse = true

	// global variable for productDocuments
	Vue.prototype.$productDocuments = []

	let isComplete = storage.getSession(STORAGE.STEP_STATUS)
	if (!isComplete) {
		isComplete = {
			step1: false,
			step2: false,
			step3: false,
			step4: false,
			step5: false,
		}
	}
	Vue.prototype.$stepStatus = isComplete

	//added default startTime and endTime
	Vue.prototype.$startTime = ''
	Vue.prototype.$endTime = ''

	Vue.config.productionTip = false
	let formData = getSessionFormData()
	if (!formData || !formData.product) {
		// formData = defaultFormData
		if (process.env.NODE_ENV !== 'production') {
			formData = formDataMock
		} else {
			formData = defaultFormData
		}
		formData = defaultFormData
		// formData = formDataMock
		setSessionFormData(formData)
	}

	Vue.prototype.$formData = new Vue({
		data() {
			return formData
		},
		watch: {
			$locale() {
				console.log('locale changed')
			},
		},
		mounted() {},
		methods: {
			getCurrentFormData() {
				let jsonData = {
					id: this.id,
					policyNumber: this.policyNumber,
					currentStep: this.currentStep,
					selectedProductIndex: this.selectedProductIndex,
					// isSubmited: this.isSubmited,
					policyHolder: this.policyHolder,
					familyMembers: this.familyMembers,
					product: this.product,
					underwritingTypeId: this.underwritingTypeId,
					underwritingQuestions: this.underwritingQuestions,
					policyDetails: this.policyDetails,
					currentSelectedFamilyIndex: this.currentSelectedFamilyIndex,
					certificateGenerate: this.certificateGenerate,
					underwritingQuestionsCount: 0
				}

				jsonData = helper.handleDefauSelectValue(jsonData, ['salutationId'])

				return JSON.parse(JSON.stringify(jsonData))
			},
		},
	})

	// Trigger get underwriting types data in dataOptions if null
	if (!dataOptions.underWritingTypes.length) {
		const formData = Vue.prototype.$formData.getCurrentFormData()
		if (formData.policyHolder.details.nationalityCountryId && Object.keys(Vue.prototype.$quote).length > 0) {
			quoteService.getUnderwritingTypesAsync(formData, dataOptions, Vue.prototype.$quote).then((res) => {
				dataOptions.underWritingTypes = res
			})
		}
	}

	Vue.prototype.$optionData = Vue.observable(dataOptions)

	// Handle locale selected - multiple languages
	let locale = Vue.observable(storage.getSession(STORAGE.LOCALE) || 'en')
	Object.defineProperty(Vue.prototype, '$locale', {
		get() {
			return locale
		},

		set(value) {
			storage.setSession(STORAGE.LOCALE, value)
			locale = value

			// Set culture to server session
			baseApi
				.post('api/setCulture', {
					culture: locale,
				})
				.then(() => {
					baseApi.get('api/options').then((dataOptions) => {
						// Keep underwritingTypes data from api
						dataOptions.underWritingTypes = this.$optionData.underWritingTypes
						Object.assign(this.$optionData, dataOptions)
					})
					quoteService.getQuoteAsync(this.$formData, this.$optionData, this.$locale).then((quote) => {
						Object.assign(this.$quote, quote)
					})
				})

			this.$i18n.locale = value
			Vue.prototype.$state.showApp = false
			setTimeout(() => {
				Vue.prototype.$state.showApp = true
			}, 10)
		},
	})

	window.onbeforeunload = () => {
		// Save current formData to sessionStorage
		const formData = Vue.prototype.$formData.getCurrentFormData()
		setSessionFormData(formData)
	}

	i18n.locale = storage.getSession(STORAGE.LOCALE)
	Promise.all([
		baseApi.post('api/setCulture', {
			culture: i18n.locale,
		}),
	])

	new Vue({
		i18n,
		store: store,
		data: {
			paymentStatus: '',
			pdfPreviewFormId: 'pdf-preview-form',
			summaryOuterHtml: ``,
			generatePreviewForm: false,
			showSummaryComponent: false,
			statusStepLogs: [], // Log status each step and error if exist
		},
		methods: {
			callUpdateQuote() {
				let quoteUpdate = this.$quote

				return new Promise((resolve, reject) => {
					quoteService
						.updateQuoteAsync(quoteUpdate)
						.then((quote) => {
							quote.products.forEach((p) => {
								p.areasOfCover.forEach((area) => {
									area.levelsOfCover.forEach((loc) => {
										quickQuoteHandler.renderBenefits(loc)
									})
								})
							})

							//this.$quote = quote
							Object.assign(this.$quote, quote)
							// cache
							// this.validPackageValue(this.$quote)
							storage.setSession(STORAGE.QUOTE, this.$quote)
							// this.$forceUpdate()

							let productSelected = this.$quote.products.find(
								(v) => v.productID === this.$formData.product.productId,
							)
							if (
								productSelected &&
								productSelected.currencies &&
								productSelected.currencies.length > 0
							) {
								let selectedProductCurrency = productSelected.currencies.find(
									(v) => v.isSelected === true,
								)
								this.$formData.policyDetails.currencyId = selectedProductCurrency.currencyID
							}
							resolve()
						})
						.catch((error) => {
							this.$toast.open({
								message: error,
								type: 'error',
								pauseOnHover: true,
							})
							reject(error)
						})
				})
			},
			inPdfPreviewForm(element) {
				const isInPdfPreview = element.closest('#' + this.pdfPreviewFormId) ? true : false
				return isInPdfPreview
			},

			/**
			 * Get values of language by key
			 * @param {String} lngKey - language key (json data)
			 * @return {List} - return value (if selected is english) or another return list value (english value and selected value)
			 */
			t(lngKey) {
				const values = []
				values.push(
					[languages['en']].concat(lngKey.split('.')).reduce(function (a, b) {
						return a[b]
					}),
				)

				if (this.$locale !== 'en') {
					values.push(
						[languages[this.$locale]].concat(lngKey.split('.')).reduce(function (a, b) {
							return a[b]
						}),
					)
				}

				return values
			},
		},
		render: (h) => h(App),
	}).$mount('#app')
}

window.submitData = false
window.getAppVersion = process.env.VUE_APP_VERSION

if (process.env.NODE_ENV === 'production') {
	const dataOptions = window.dataOptions || {}
	const broker = window.broker || null
	Bootstrap(dataOptions, broker)
} else {
	let params = new URLSearchParams(window.location.search),
		brokerRef = params.get('ref')

	Promise.all([baseApi.get('api/options'), baseApi.get('api/broker?brokerRef=' + brokerRef)]).then(
		([dataOptions, broker]) => {
			Bootstrap(dataOptions, brokerRef ? broker : null)
		},
	)
}
